<template>
    <div class="story-maker-sticker-menu-product">

        <div class="section-shop" v-if="!shopSelected">
            <div class="header-menu">
                <p>{{ $t('dash.post-creator.story.shop-title') }}</p>
            </div>
            <div class="search-bar">
                <i class="fa-regular fa-magnifying-glass"></i>
                <input :placeholder="$t('dash.post-creator.overlay.search')" v-model="models.searchShop">
            </div>
        
            <div class="container-shop hide-scrollbar">
                <span class="loader" v-if="loading.shop"></span>
                <template v-else>
                    <p v-if="!models.searchShop.length" class="title">{{ $t('dash.post-creator.overlay.suggested-shops') }}</p>
                    <div class="list list-shop hide-scrollbar">
                        <div class="item" v-for="(shop,index) in (models.searchShop.length ? shops : dataInstagramDefault.shops)" @click="selectShop(shop)" :key="shop.id">
                            <img :src="shop.image">
                            <p class="shop-title">{{shop.text}}</p>
                        </div>
                    </div>

                </template>
               
            </div>
        </div>

        <div class="section-product" v-else>
            <div class="header-menu">
                <div class="return" @click="closeProductList"></div>
                <p>{{ shopSelected.text }}</p>
            </div>
            <div class="search-bar">
                <i class="fa-regular fa-magnifying-glass"></i>
                <input :placeholder="$t('dash.post-creator.overlay.search')" v-model="models.searchProduct">
            </div>
        
            <div class="container-product">
                <p class="title" v-if="!models.searchProduct.length">{{ $t('dash.post-creator.overlay.suggested-products') }}</p>
                <div class="list list-product hide-scrollbar">
                    <span class="loader" v-if="loading.product"></span>
                    <div class="item" v-else v-for="(product,index) in (models.searchProduct.length ? products : defaultProducts)" @click="selectProduct(product)" :class="{active: productsSelected.some(p => p.id == product.id), disable: productsSelected.length == 5}" :key="product.id">
                        <div class="image">
                            <img :src="product.image">
                        </div>
                        <div class="info">
                            <p class="product-name">{{ product.text}}</p>
                            <p class="product-price">{{ product.description}}</p>
                        </div>
                        
                        <div class="check">
                        </div>
                    </div>
                </div>
            </div>

            <div class="container-select-variant" v-if="productSelected">
                <div class="select-variant">
                    <h5>{{ $t('dash.post-creator.overlay.variant-choice') }}</h5>
                    <div class="list-item-variant hide-scrollbar">
                        <span class="loader" v-if="loading.productVariant"></span>
                        <div class="item" v-else v-for="(product,index) in variantsProducts" @click="selectVariant(product)">
                            <img :src="product.image">
                            <p class="product-name">{{ product.number}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="button" v-if="productsSelected.length" @click="finish">{{ $t('dash.post-creator.story.validate-count', { count: productsSelected.length }) }}</div>
    </div>
</template>


<script>
    import store from '@/store/index.js';
    import minxinPost from '@/components/mixins/Posts.vue'
    import { stickerDataDefault } from './main.vue';

    export default {
        mixins: [minxinPost],

        props: {
            dataInstagramDefault: Object,
        },

        data() {
            return {
                models: {
                    searchShop : '',
                    searchProduct : '',
                },
                stateLoader : false,

                //shop
                shops : [],
                shopSelected: null,

                //product
                defaultProducts : [],
                products : [],
                productSelected : null,
                variantsProducts: [],


                //data 
                productsSelected : [],


                timeout:{
                    shop : null,
                    product : null
                },

                loading:{
                    shop : null,
                    product : null,
                    productVariant : null
                }

            }
        },

        methods: {

            async finish() {
                if (this.productsSelected.length) {
                    this.$emit('addSticker','product', {
                        isEditing: true,
                        data: {
                            ...stickerDataDefault.product.data,
                            products : this.productsSelected.slice(0,5).map((product) => {
                                product.image = null
                                return product
                            })
                        }
                    })
                }
            
            },

            async searchShop() {
                console.log('searchShop')
                this.loading.shop = false
                if (this.timeout.shop) clearTimeout(this.timeout.shop)
                this.shops = []

                if (!this.models.searchShop) {
                    console.log('searchShop clem', this.dataInstagramDefault.shops)
                    this.shops = this.dataInstagramDefault.shops || []
                    return 
                }

                this.loading.shop = true
                this.timeout.shop = setTimeout(async () => {
                    let page = this.pagesSelected.find(p => p.network == 'instagram' && p.story_config && p.story_config.created)
                    if (page) {
                        
                        this.shops = (await this.searchShopsInstagram(page.id, this.models.searchShop)).body.shops
                        this.loading.shop = false
                    }
                },1000)
                
            },

            async searchProduct() {
                this.loading.product = false
                if (this.timeout.product) clearTimeout(this.timeout.product)
                this.products = []
                if (!this.models.searchProduct) {
                    this.products = this.defaultProducts
                    return 
                }

                this.loading.product = true
                this.timeout.product = setTimeout(async () => {
                    let page = this.pagesSelected.find(p => p.network == 'instagram' && p.story_config && p.story_config.created)
                    if (page) {
                        this.products = (await this.searchItemsShopInstagram(page.id, this.shopSelected.id , this.models.searchProduct)).body.items
                        this.loading.product = false
                    }
                },1000)
            },

            async selectShop(shop) {
                this.shopSelected = shop
                let page = this.pagesSelected.find(p => p.network == 'instagram' && p.story_config && p.story_config.created)
                this.models.searchProduct = ''
                this.products = []
                this.defaultProducts = []
                if (page) {
                    this.loading.product = true
                    this.defaultProducts = (await this.getTrendItemsShopInstagram(page.id, shop.id)).body.items	
                    this.loading.product = false
                }
            },

            async selectProduct(product) {
                if (!this.shopSelected) return 
                if (this.productsSelected.some(p => p.id == product.id)) {
                    this.productsSelected =  this.productsSelected.filter(p => p.id !== product.id)
                    return
                }
                if (this.productsSelected.length == 5) return
                product.shopId = this.shopSelected.id
                if (product.variant == true) {
                    this.productSelected = product
                    let page = this.pagesSelected.find(p => p.network == 'instagram' && p.story_config && p.story_config.created)

                    if (page) {
                        this.loading.productVariant = true
                        let items = null
                        try {
                            let res = await this.chooseItemShopInstagram(page.id, product.id, this.shopSelected.id)
                            if (res && res.body && res.body.noVariant !== true && res.body.items && res.body.items.length) {
                                items = res.body.items
                            }
                        } catch (e) {
                            console.error('chooseItemShopInstagram failed', e)
                        } finally {
                            this.loading.productVariant = false
                        }

                        if (items) {
                            this.variantsProducts = items
                        } else {
                            this.variantsProducts = []
                            this.productSelected = null
                            this.productsSelected = [...this.productsSelected, product]
                        }
                    } else {
                        console.log('selectProduct: no Instagram page with a created story_config found, tagging product without variant lookup', { productId: product.id, shopId: this.shopSelected.id })
                        this.variantsProducts = []
                        this.productSelected = null
                        this.productsSelected = [...this.productsSelected, product]
                    }
                }else{
                   
                    this.productsSelected = [...this.productsSelected, product]
                }
            },

            selectVariant(productVariant) {
            
                this.selectProduct({
                    ...this.productSelected,
                    variant : productVariant
                })

                this.closeVariantSelection()
            },

            closeVariantSelection() {
                this.variantsProducts = []
                this.productSelected = null
            },

            closeProductList() {
                this.variantsProducts = []
                this.productSelected = null
                this.shopSelected = null
                this.defaultProducts = []
                this.products = []
            }
        },

        computed: {
            allPages() {
                return this.$store.getters['selectPage/selectPageAllPages'];
            },
            pagesSelected() {
                return this.$store.getters['selectPage/selectPagePageSelected'].map(id => this.allPages[id]);
            },
        },

        watch: {
            ['models.searchShop'](newValue, oldValue) {
                this.searchShop()
            },
            ['models.searchProduct'](newValue, oldValue) {
                this.searchProduct()
            },
            
        },
    }
</script>

<style lang="scss" scoped>

</style>

https://sandbox.api.saas.mashup-web.com/posts/itemshop-choose?page=c6ec0cf4-5f05-4e5c-ab4a-aefc06e3e092&product=3632903630141695&merchant=293386308&simulate=false